const mpxnValidator = (value: string | null) => {
  if (!value) {
    return "MPXN is required"
  }

  const trimmedValue = value.trim()

  // Check if it contains only digits
  if (!/^\d+$/.test(trimmedValue)) {
    return "MPXN must contain only numbers"
  }

  const length = trimmedValue.length

  // MPAN: 13 digits
  if (length === 13) {
    return true
  }

  // MPRN: 6-10 digits
  if (length >= 6 && length <= 10) {
    return true
  }

  return "MPXN must be either 6-10 digits (MPRN) or 13 digits (MPAN)"
}

export default mpxnValidator
